/**
 * type for page download progress. This is used in offline status service but could also be used for other purposes like search
 * page download progress
 */
export interface PageDownloadProgress  {
    pageNumber: number;
    loaded: number;
    total: number;
}
